module.exports = __webpack_public_path__ + "img/item5.1c07eca9.png";